
import { CitationPlugin } from '@alpod-ai-writer/plate-plugins/citations/react';
import { FootnotesPlugin } from '@alpod-ai-writer/plate-plugins/footnotes/react';
import { ShortcutPlugin } from '@alpod-ai-writer/plate-plugins/shortcuts/react';
import type { DropdownMenuProps } from '@radix-ui/react-dropdown-menu';
import { useEditorPlugin } from '@udecode/plate/react';
import {
    BookTextIcon,
    FileSymlinkIcon,
    HashIcon,
    ListEndIcon,
} from 'lucide-react';

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuTrigger,
    useOpenState,
} from '../common/dropdownMenu.component';
import { ToolbarButton } from '../common/toolbar.component';

export function InsertDropdownMenu({ ...props }: DropdownMenuProps) {
    const footnotesPlugin = useEditorPlugin(FootnotesPlugin);
    const citationPlugin = useEditorPlugin(CitationPlugin);
    const shortcutPlugin = useEditorPlugin(ShortcutPlugin);

    const openState = useOpenState();

    return (
        <DropdownMenu modal={false} {...openState} {...props}>
            <DropdownMenuTrigger asChild>
                <ToolbarButton pressed={openState.open} tooltip="Vložit" isDropdown>
                    <FileSymlinkIcon />
                </ToolbarButton>
            </DropdownMenuTrigger>

            <DropdownMenuContent className="min-w-0" align="start">
                <DropdownMenuGroup>
                    <DropdownMenuItem
                        onSelect={() =>
                            footnotesPlugin.tf.insert.footnote()
                        }
                    >
                        <ListEndIcon /> Poznámka pod čarou
                    </DropdownMenuItem>

                    <DropdownMenuItem
                        onSelect={() =>
                            citationPlugin.tf.insert.citationInput({
                                search: '',
                                value: '__new__'
                            })
                        }
                    >
                        <BookTextIcon /> Citace
                    </DropdownMenuItem>

                    <DropdownMenuItem
                        onSelect={() =>
                            shortcutPlugin.tf.insert.shortcutInput({
                                search: '',
                                value: '__new__'
                            })
                        }
                    >
                        <HashIcon /> Zkratka
                    </DropdownMenuItem>
                </DropdownMenuGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
